import { jsx as _jsx } from "react/jsx-runtime";
import { AddCircleOutline, CreateNewFolder, Delete, DriveFileRenameOutline, DriveFolderUpload, } from '@mui/icons-material';
import { preventDefault, useCallbacks, usePartial, usePreventDefault, } from 'shared/hooks/utils';
import { addGroupInDeviceTree, deleteGroupInDeviceTree, expandGroupInDeviceTree, renameGroupInDeviceTree, } from 'console/redux/devices/tree/actions';
import { openGroupNameDialog } from 'console/sortableDeviceTree/rename-group-dialog/actions';
import { partial } from 'lodash';
import { memo, useCallback, useMemo } from 'react';
import { UniversalMenu } from 'console/shared/components/menu';
import { useNavigateTo } from 'shared/hooks/router';
import { openGroupSelectorDialog } from 'console/sortableDeviceTree/add-group-selector-dialog/actions';
import { useDisableAddToGroup } from 'console/sortableDeviceTree/add-group-selector-dialog/utils/group-selector-utils';
import { useAction } from 'shared/hooks/redux/hooks';
export const GroupMenu = memo(function GroupMenu(props) {
    const { onClose, anchor, can_manage_devices, can_manage_groups, node, path } = props;
    const disable_group_to_group = useDisableAddToGroup(node);
    const onAddGroupInDeviceTree = useAction(addGroupInDeviceTree);
    const onOpenRenameGroupDialog = useAction(openGroupNameDialog);
    const onRenameGroupInDeviceTree = useAction(renameGroupInDeviceTree);
    const onExpandGroupInDeviceTree = useAction(expandGroupInDeviceTree);
    const onDeleteGroupInDeviceTree = useAction(deleteGroupInDeviceTree);
    const onOpenGroupSelectorDialog = useAction(openGroupSelectorDialog);
    const onChangeName = usePartial(onOpenRenameGroupDialog, node.title, partial(onRenameGroupInDeviceTree, path));
    const onAddGroupToGroup = useCallback(() => {
        onOpenGroupSelectorDialog(node);
        onClose();
    }, [path, onOpenGroupSelectorDialog, onClose]);
    const onAdd = useCallback(() => {
        const on_ok_function = (group_name) => {
            onExpandGroupInDeviceTree(path, true);
            onAddGroupInDeviceTree(path, group_name);
        };
        onOpenRenameGroupDialog('', on_ok_function);
    }, [
        path,
        onExpandGroupInDeviceTree,
        onAddGroupInDeviceTree,
        onOpenRenameGroupDialog,
    ]);
    const onDelete = usePartial(onDeleteGroupInDeviceTree, path);
    const onCloseContextMenu = usePreventDefault(onClose);
    const addClick = useCallbacks([preventDefault, onAdd, onClose]);
    const deleteClick = useCallbacks([preventDefault, onDelete, onClose]);
    const changeNameClick = useCallbacks([preventDefault, onChangeName, onClose]);
    const navigate = useNavigateTo(`/new-device`);
    // FIXME: need add device to group
    const addDevice = useCallback(() => {
        navigate();
        onClose();
    }, [onClose]);
    const menu_items = useMemo(() => [
        {
            icon: _jsx(DriveFileRenameOutline, { color: "action" }),
            label: 'Переименовать группу',
            onClick: changeNameClick,
            show: can_manage_groups,
        },
        {
            icon: _jsx(DriveFolderUpload, { color: "action" }),
            label: 'Переместить в группу',
            onClick: onAddGroupToGroup,
            show: can_manage_groups,
            disabled: disable_group_to_group,
        },
        {
            icon: _jsx(CreateNewFolder, { color: "action" }),
            label: 'Добавить группу',
            onClick: addClick,
            show: can_manage_groups,
        },
        {
            icon: _jsx(Delete, { color: "action" }),
            label: 'Расформировать группу',
            onClick: deleteClick,
            show: can_manage_groups,
        },
        {
            icon: _jsx(AddCircleOutline, { color: "action" }),
            label: 'Добавить устройство в группу',
            onClick: addDevice,
            show: can_manage_devices,
        },
    ], [
        can_manage_groups,
        can_manage_devices,
        addDevice,
        deleteClick,
        addClick,
        changeNameClick,
        onAddGroupToGroup,
    ]);
    return (_jsx(UniversalMenu, { anchor: anchor, menu_items: menu_items, onClose: onCloseContextMenu, opened: !!anchor }));
});
